import { render, staticRenderFns } from "./help.vue?vue&type=template&id=d0d95a7c&"
import script from "./help.vue?vue&type=script&lang=ts&"
export * from "./help.vue?vue&type=script&lang=ts&"
import style0 from "./help.vue?vue&type=style&index=0&id=d0d95a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports